import { diatonicTranspose } from "@/components/pitchCorrection/diatonicTranspose";
import { useNamedPitchCorrection } from "@/lib/zustand/usePitchCorrection";
import { KeyOption } from "@/types/defs/keyOption";

export const makeDiatonicTranspose = (key: KeyOption, namespace: string) => {
  const usePitchCorrection = useNamedPitchCorrection((state) =>
    state.getNamedStore(namespace)
  );
  const circles = usePitchCorrection((state) => state.circles);
  const pitches = usePitchCorrection((state) => state.pitches);

  return diatonicTranspose(key, circles, pitches);
};
